import { Link } from 'react-router-dom';
import { check } from '../../utils/tokenUtils';

const FooterColumn = ({ col, link }) => {
  const className = `col-sm-${col} col-12`;
  return (
    <div className={className}>
      <ul>
        {link.href === '/logout' && !check() ? (
          <li>
            <Link target={link.target} to='/'>
              Login
            </Link>
          </li>
        ) : (
          <li>
            <Link target={link.target} to={link.href}>
              {link.title}
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default FooterColumn;
